import React, { useState } from "react";
import { Accordion } from "@/components/ui/accordion";
import ProductDetailsIcon from "@/icons/product-details";
import Dimensions from "@/icons/dimensions";
import Items from "@/icons/items";
export default function ProductDetailsAccordion({ product }) {
  const iconClass = "w-6 items-center flex justify-center text-brown";
  const [expanded, setExpanded] = useState(-1);
  const data = [
    {
      title: "Product Details",
      icon: <ProductDetailsIcon className={`${iconClass}`} />,
      content: (
        <div dangerouslySetInnerHTML={{ __html: product?.description }} />
      ),
    },
    {
      title: "Dimensions",
      icon: <Dimensions className={`${iconClass}`} />,
      content: (
        <div className="flex flex-row gap-8">
          <p className="text-darkGrey font-bold [&>span]:font-normal">
            Length: <span>{product?.dimensions.length}</span>
          </p>
          <p className="text-darkGrey font-bold [&>span]:font-normal">
            Width: <span>{product?.dimensions.width}</span>
          </p>
          <p className="text-darkGrey font-bold [&>span]:font-normal">
            Height: <span>{product?.dimensions.height}</span>
          </p>
        </div>
      ),
    },
    {
      title: "Color and Size",
      icon: <ProductDetailsIcon className={`${iconClass}`} />,
      content: (
        <div className="flex flex-row gap-8">
          <p className="text-darkGrey font-bold [&>span]:font-normal">
            Size: <span>{product?.size?.data?.attributes?.name}</span>
          </p>
          <p className="text-darkGrey font-bold [&>span]:font-normal">
            Color: <span>{product?.color?.data?.attributes?.name}</span>
          </p>
        </div>
      ),
    },
    // {
    //   title: "Product Details",
    //   icon: <ProductDetailsIcon className={`${iconClass}`} />,
    //   content: (
    //     <>
    //       <p>{product?.description}</p>
    //     </>
    //   ),
    // },
  ];
  return (
    <div className="flex flex-col w-full">
      {data.map((item, index) => (
        <Accordion
          key={item.title + index}
          i={index} // Pass index
          title={item.title}
          content={item?.content}
          icon={item.icon}
          open={index === expanded} // Check if the current accordion is open
          setExpanded={setExpanded} // Pass function to set expanded accordion
          expanded={expanded} // Pass expanded state
        >
          {item?.content}
        </Accordion>
      ))}
    </div>
  );
}
